const periodsKey = '/period';

export const periods = () => {
  return `${periodsKey}/all`;
};

export const currentPeriod = () => {
  return `${periodsKey}/current`;
};
